import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import rzeus from '../assets/brand-zeus.jpg'
import hermes from '../assets/brand-hermes.jpg'
import poseidon from '../assets/brand-poseidon.jpg'
// mui
import Card from '@material-ui/core/Card'
import CardActionArea from '@material-ui/core/CardActionArea'

const BrandCard = props => {
    const dispatch = useDispatch()

    let brandImage = ''
    if (props.brand === 'rzeus') {
        brandImage = rzeus;
    } else if (props.brand === 'hermes') {
        brandImage = hermes;
    } else {
        brandImage = poseidon;
    }

    return (
        <CardWrapper>
            <CardActionArea onClick={()=>dispatch(push('/brand/' + props.brand))}>
                <BrandImageWrapper>
                    <BrandImage src={brandImage} alt={props.brand} />
                </BrandImageWrapper>
                <Title>{props.brand.toUpperCase()}</Title>
                {/* <LinkWrapper>
                    <LinkText>Product List</LinkText>
                </LinkWrapper> */}
            </CardActionArea>
        </CardWrapper>
    )
}
export default BrandCard

const CardWrapper = styled(Card)`
    width: 300px;
    cursor: pointer;
    @media screen and (max-width:768px){
        margin-bottom: 20px;
    }
`
const BrandImageWrapper = styled.div`
    overflow: hidden;
    background-color: #7ABECE;
`
const BrandImage = styled.img`
    width: 100%;
    height: 400px;
    object-fit: cover;
    transition: 1s all; 
    filter: saturate(0%);
    &:hover {
        transition: 1s all;
        opacity: 0.5;
        display:block;
        /* filter: saturate(100%); */
        /* transform: scale(1.1); */
    }
`
const Title = styled.p`
    width: 100%;
    text-align: center;
    font-size: 2rem;
    padding: 0.2rem;
    color: #fff;
    background-color: #000;
`
// const LinkWrapper = styled.div`
//     width: 300px;
//     text-align: right;
//     padding: 1.2rem 0 0 0;
//     font-size: .9rem;
// `
// const LinkText = styled.p`
//     padding-bottom: 10px;
//     position: relative;
//     font-size: 1.25rem;
//     display: inline-block;
//     text-decoration: none;
//     &::before {
//         position: absolute;
//         bottom: -2px;
//         left: 0;
//         content: '';
//         width: 100%;
//         height: 1px;
//         background: #fff;
//         transform: scale(0, 1);
//         transform-origin: left top;
//         transition: transform .3s;
//     }
//     &:hover::before {
//         transform: scale(1, 1);
//     }
// `